import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'
import {type DeleteAccountParams, type DeleteAccountResponse} from './types'

/**
 * Confirm account deletion with WID approval token.
 * The approvalToken must come from polling requestDeleteAccount via quicklogin.status.
 */
export async function deleteAccount(
  agent: BskyAgent,
  params: DeleteAccountParams,
  options?: {signal?: AbortSignal},
): Promise<DeleteAccountResponse> {
  const accessJwt = agent.session?.accessJwt
  const did = agent.session?.did
  if (!accessJwt || !did) {
    throw new Error('No active session available')
  }
  return wsocFetch<DeleteAccountResponse>(
    xrpcPath('io.trustanchor.server.deleteAccountWID'),
    {
      body: {did, token: params.approvalToken},
      accessJwt,
      signal: options?.signal,
    },
  )
}
